export const PLAYER = {
  category: `players`,
  type: `player`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <title>player</title>
    <path class="background" d="M30 16c0 7.732-6.268 14-14 14s-14-6.268-14-14c0-7.732 6.268-14 14-14s14 6.268 14 14z"></path>
    <path d="M16 4.8c6.186 0 11.2 5.014 11.2 11.2s-5.014 11.2-11.2 11.2c-6.186 0-11.2-5.014-11.2-11.2v0c0-6.186 5.014-11.2 11.2-11.2v0zM16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16v0c0-8.837-7.163-16-16-16v0z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 18,
      width: 18,
    },
    M: {
      height: 20,
      width: 20,
    },
    L: {
      height: 25,
      width: 25,
    },
  },
  text: ``,
  actions: {
    rotate: false,
    text: true,
  },
};

export const GOALKEEPER = {
  category: `players`,
  type: `goalkeeper`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <title>goalkeeper</title>
    <path class="background" d="M30 16c0 7.732-6.268 14-14 14s-14-6.268-14-14c0-7.732 6.268-14 14-14s14 6.268 14 14z"></path>
    <path d="M28.533 27.467c0.533 0.4 0.8 1.067 0.8 1.867 0 1.467-1.2 2.667-2.667 2.667-0.8 0-1.467-0.267-1.867-0.8-0.4-0.4-0.8-0.8-1.2-1.2-1.733-1.733-2.667-2.667-4-4 1.733-0.667 3.2-1.733 4.4-3.067 1.6-1.867 2.667-4.267 2.667-6.933 0-5.867-4.8-10.667-10.667-10.667s-10.667 4.8-10.667 10.667c0 2.667 1.067 5.067 2.667 6.933 1.2 1.333 2.667 2.4 4.533 3.067-1.333 1.333-2.267 2.267-4 4-0.4 0.4-0.667 0.667-1.2 1.2s-1.2 0.8-2 0.8c-1.467 0-2.667-1.2-2.667-2.667 0-0.8 0.267-1.467 0.8-1.867 0.267-0.267 0.533-0.533 0.667-0.667-2.533-2.933-4.133-6.667-4.133-10.8 0-8.8 7.2-16 16-16s16 7.2 16 16c0 4.133-1.6 7.867-4.133 10.8 0.133 0.133 0.4 0.4 0.667 0.667z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 18,
      width: 18,
    },
    M: {
      height: 20,
      width: 20,
    },
    L: {
      height: 25,
      width: 25,
    },
  },
  text: `GK`,
  actions: {
    rotate: true,
    text: true,
  },
};

export const USSF_TRIANGLE_PLAYER = {
  category: `players`,
  type: `ussf_triangle_player`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <title>ussf-triangle-player</title>
    <path d="M32 32l-12-24h-8l-12 24h32z"></path>
    <path fill="#000" d="M16 0l-4 8h8l-4-8z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 18,
      width: 18,
    },
    M: {
      height: 20,
      width: 20,
    },
    L: {
      height: 25,
      width: 25,
    },
  },
  text: ``,
  actions: {
    rotate: true,
    text: true,
  },
};

export const USSF_CIRCLE_PLAYER = {
  category: `players`,
  type: `ussf_circle_player`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <title>ussf-circle-player</title>
    <path d="M29.84 8h-27.68c-1.358 2.302-2.16 5.071-2.16 8.028 0 8.837 7.163 16 16 16s16-7.163 16-16c0-2.957-0.802-5.727-2.201-8.103l0.041 0.075z"></path>
    <path fill="#000" d="M16 0c-5.885 0.006-11.025 3.188-13.799 7.925l-0.041 0.075h27.68c-2.815-4.812-7.955-7.994-13.839-8h-0.001z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 18,
      width: 18,
    },
    M: {
      height: 20,
      width: 20,
    },
    L: {
      height: 25,
      width: 25,
    },
  },
  text: ``,
  actions: {
    rotate: true,
    text: true,
  },
};

export const BALL = {
  category: `equipment`,
  type: `ball`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <title>ball</title>
    <path fill="#140a1e" d="M16.043 32.059c8.749-0.004 15.936-7.133 16.010-16.097-0.004-8.749-7.348-16.014-16.097-16.010s-15.936 7.133-16.010 16.097c0.004 8.749 7.348 16.014 16.097 16.010z"></path>
    <path fill="#fff" d="M14.851 24.582l-3.433 1.435c-1.29-0.465-2.64-1.438-3.698-2.548l0.38-3.751 4.586-1.262 2.055 1.713 0.11 4.413z"></path>
    <path fill="#fff" d="M20.597 26.168l-3.363-1.456-0.032-4.628 2.066-1.685 4.593 1.413 0.342 3.768c-0.895 1.135-2.143 1.9-3.606 2.588z"></path>
    <path fill="#fff" d="M25.75 10.53c0.765 1.248 1.238 2.633 1.34 4.371l-2.376 2.545-3.948-1.181-1.005-3.278 2.393-3.268 3.596 0.81z"></path>
    <path fill="#fff" d="M13.665 4.958c0.8-0.197 1.523-0.18 2.245-0.162s1.66 0.113 2.383 0.13l1.943 3.373-2.161 2.623-4.121-0.028-1.96-2.651 1.671-3.286z"></path>
    <path fill="#fff" d="M10.006 9.713l2.45 3.313-0.948 3.303-3.863 1.28-2.468-2.591c0.113-1.66 0.578-2.951 1.336-4.378l3.493-0.927z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 12,
      width: 12,
    },
    M: {
      height: 13,
      width: 13,
    },
    L: {
      height: 15,
      width: 15,
    },
  },
  actions: {
    rotate: false,
    text: false,
  },
};

export const GOAL_LARGE = {
  category: `equipment`,
  type: `goal_large`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="104" height="32" viewBox="0 0 104 32">
    <title>goal-large</title>
    <path d="M12 14c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M16 10c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M20 14c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M24 10c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M28 14c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M32 10c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M36 14c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M40 10c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M44 14c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M48 10c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M52 14c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M56 10c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M60 14c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M64 10c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M68 14c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M72 10c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M76 14c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M80 10c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M84 14c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M88 10c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M16 18c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M24 18c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M32 18c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M40 18c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M48 18c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M56 18c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M64 18c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M72 18c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M80 18c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M88 18c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M92 14c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M12 22c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M20 22c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M28 22c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M36 22c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M44 22c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M52 22c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M60 22c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M68 22c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M76 22c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M84 22c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M92 22c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M12 6c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M20 6c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M28 6c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M36 6c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M44 6c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M52 6c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M60 6c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M68 6c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M76 6c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M84 6c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M92 6c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"></path>
    <path d="M96 0h-88c-2.209 0-4 1.791-4 4v0 20c0 2.209-1.791 4-4 4v0 4h104v-4c-2.209 0-4-1.791-4-4v0-20c0-2.209-1.791-4-4-4v0zM8 28v-24h88v24z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 15,
      width: 49,
    },
    M: {
      height: 18,
      width: 60,
    },
    L: {
      height: 28,
      width: 90,
    },
  },
  actions: {
    rotate: true,
    text: false,
  },
};

export const GOAL_SMALL = {
  category: `equipment`,
  type: `goal_small`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="56" height="32" viewBox="0 0 56 32">
    <title>goal-small</title>
    <path d="M12 14h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M16 10h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M20 14h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M24 10h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M27.999 14h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M31.999 10h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M35.999 14h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M39.999 10h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M44 14h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M16 18h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M24 18h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M31.999 18h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M39.999 18h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M12 21.999h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M20 21.999h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M27.999 21.999h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M35.999 21.999h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M44 21.999h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M12 6h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M20 6h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M27.999 6h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M35.999 6h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M44 6h0.001c1.104 0 2 0.895 2 2v0.001c0 1.104-0.895 2-2 2h-0.001c-1.104 0-2-0.895-2-2v-0.001c0-1.104 0.895-2 2-2z"></path>
    <path d="M55.999 28v0c-2.209-0-3.999-1.791-3.999-4v-20c0-2.209-1.791-4-4-4v0h-39.999c-0 0-0 0-0.001 0-2.209 0-3.999 1.791-3.999 3.999 0 0 0 0.001 0 0.001v-0 20c0 2.209-1.791 4-4 4v0 4h55.999zM8 28v-24h39.999v24z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 12,
      width: 21,
    },
    M: {
      height: 15,
      width: 26,
    },
    L: {
      height: 22,
      width: 39,
    },
  },
  actions: {
    rotate: true,
    text: false,
  },
};

export const CONE_LARGE = {
  category: `equipment`,
  type: `cone_large`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32">
    <title>cone-large</title>
    <path d="M12.226 0l12.226 31.059h-24.453l12.226-31.059z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 14,
      width: 11,
    },
    M: {
      height: 17,
      width: 13,
    },
    L: {
      height: 19,
      width: 15,
    },
  },
  actions: {
    rotate: true,
    text: false,
  },
};

export const CONE_SMALL = {
  category: `equipment`,
  type: `cone_small`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <title>cone-small</title>
    <path d="M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 6,
      width: 6,
    },
    M: {
      height: 8,
      width: 8,
    },
    L: {
      height: 10,
      width: 10,
    },
  },
  actions: {
    rotate: false,
    text: false,
  },
};

export const MANNEQUIN = {
  category: `equipment`,
  type: `mannequin`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="77" height="32" viewBox="0 0 77 32">
    <title>mannequin</title>
    <path fill="#fff" d="M25.596 17.597c0 2.651-2.149 4.799-4.799 4.799v0h-12.798c-2.651 0-4.799-2.149-4.799-4.799v0 0c0-2.651 2.149-4.799 4.799-4.799v0h12.798c2.651 0 4.799 2.149 4.799 4.799v0z"></path>
    <path fill="#fff" d="M71.989 15.998c0.008 0.115 0.012 0.249 0.012 0.385 0 3.046-2.24 5.568-5.162 6.010l-0.034 0.004h-10.43c-2.956-0.446-5.195-2.969-5.195-6.014 0-0.135 0.004-0.27 0.013-0.403l-0.001 0.018c-0.008-0.115-0.012-0.249-0.012-0.385 0-3.046 2.24-5.568 5.162-6.010l0.034-0.004h10.43c2.956 0.446 5.195 2.969 5.195 6.014 0 0.135-0.004 0.27-0.013 0.403l0.001-0.018z"></path>
    <path fill="#fff" d="M38.394 3.2c7.068 0 12.798 5.73 12.798 12.798s-5.73 12.798-12.798 12.798c-7.068 0-12.798-5.73-12.798-12.798s5.73-12.798 12.798-12.798z"></path>
    <path fill="#fff" d="M50.936 24.156c0.159-0.526 0.253-1.131 0.256-1.758v-12.8c-0.003-0.628-0.097-1.233-0.268-1.805l0.012 0.045c0.539 1.052 1.615 1.76 2.857 1.76 0.008 0 0.016-0 0.023-0h13.373c1.764 0.008 3.358 0.728 4.511 1.887l0 0c0.297 0.291 0.57 0.605 0.817 0.939l0.015 0.021c-0.263-0.368-0.536-0.692-0.833-0.993l0.001 0.001c-1.156-1.147-2.748-1.856-4.506-1.856-0.002 0-0.004 0-0.005 0h-12.798c-1.767 0-3.2 1.432-3.2 3.2v0 6.399c0 1.767 1.432 3.2 3.2 3.2v0h-0.576c-0.007-0-0.014-0-0.022-0-1.242 0-2.319 0.708-2.849 1.742l-0.008 0.018zM25.852 24.156c-0.539-1.052-1.615-1.76-2.857-1.76-0.008 0-0.016 0-0.023 0h-0.575c1.767 0 3.2-1.432 3.2-3.2v0 3.2c0.003 0.628 0.097 1.233 0.268 1.805l-0.012-0.045zM67.19 22.397c1.764-0.008 3.358-0.728 4.511-1.887l0-0c0.216-0.189 0.405-0.399 0.568-0.629l0.007-0.011c-0.171 0.241-0.36 0.451-0.572 0.636l-0.004 0.004c-1.153 1.16-2.747 1.88-4.51 1.888h-0.001zM9.599 22.397c-1.764-0.008-3.358-0.728-4.511-1.887l-0-0c-0.297-0.275-0.561-0.579-0.788-0.91l-0.012-0.018c0.264 0.356 0.526 0.669 0.805 0.965l-0.005-0.006c1.156 1.147 2.748 1.856 4.506 1.856 0.002 0 0.004 0 0.005 0h-0zM25.596 12.798c0-1.767-1.432-3.2-3.2-3.2v0h-12.798c-1.764 0.008-3.358 0.728-4.511 1.887l-0 0c-0.217 0.206-0.417 0.425-0.598 0.659l-0.010 0.013c0.191-0.247 0.39-0.466 0.605-0.669l0.003-0.003c1.153-1.16 2.747-1.88 4.51-1.888h13.375c0.007 0 0.014 0 0.022 0 1.242 0 2.319-0.708 2.849-1.742l0.008-0.018c-0.159 0.526-0.253 1.131-0.256 1.758v0.002zM31.995 3.2v0z"></path>
    <path fill="#2f313c" d="M44.793 0h-12.798c-4.143 0.012-7.668 2.647-9.002 6.332l-0.021 0.067h-13.374c-5.301 0-9.599 4.297-9.599 9.599s4.297 9.599 9.599 9.599v0h13.374c1.354 3.752 4.879 6.387 9.021 6.399h12.8c4.143-0.012 7.668-2.648 9.002-6.332l0.021-0.067h13.374c5.301 0 9.599-4.297 9.599-9.599s-4.297-9.599-9.599-9.599v0h-13.374c-1.354-3.752-4.879-6.387-9.021-6.399h-0.001zM31.995 25.596c-1.767 0-3.2-1.432-3.2-3.2v0-12.798c0-1.767 1.432-3.2 3.2-3.2v0h12.798c1.767 0 3.2 1.432 3.2 3.2v0 12.798c0 1.767-1.432 3.2-3.2 3.2v0zM54.392 19.197v-6.399h12.798c0.005-0 0.012-0 0.019-0 0.879 0 1.675 0.354 2.253 0.928l-0-0c0.585 0.58 0.946 1.384 0.946 2.272s-0.362 1.692-0.946 2.271l-0 0c-0.578 0.573-1.374 0.928-2.253 0.928-0.007 0-0.013-0-0.019-0h0.001zM9.599 19.197c-0.005 0-0.012 0-0.018 0-0.879 0-1.675-0.354-2.253-0.928l0 0c-0.585-0.58-0.946-1.384-0.946-2.272s0.362-1.692 0.946-2.271l0-0c0.578-0.573 1.374-0.928 2.253-0.928 0.007 0 0.013 0 0.020 0h12.797v6.399z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 8,
      width: 19,
    },
    M: {
      height: 10,
      width: 22,
    },
    L: {
      height: 13,
      width: 30,
    },
  },
  actions: {
    rotate: true,
    text: false,
  },
};

export const LADDER = {
  category: `equipment`,
  type: `ladder`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="101" height="32" viewBox="0 0 101 32">
    <title>ladder</title>
    <path fill="#2F313C" d="M0 27.429h100.571v4.571h-100.571v-4.571z"></path>
    <path fill="#2F313C" d="M0 0h100.571v4.571h-100.571v-4.571z"></path>
    <path fill="#2F313C" d="M6.857 4.571h4.571v22.857h-4.571v-22.857z"></path>
    <path fill="#2F313C" d="M20.571 4.571h4.571v22.857h-4.571v-22.857z"></path>
    <path fill="#2F313C" d="M34.286 4.571h4.571v22.857h-4.571v-22.857z"></path>
    <path fill="#2F313C" d="M48 4.571h4.571v22.857h-4.571v-22.857z"></path>
    <path fill="#2F313C" d="M61.714 4.571h4.571v22.857h-4.571v-22.857z"></path>
    <path fill="#2F313C" d="M75.429 4.571h4.571v22.857h-4.571v-22.857z"></path>
    <path fill="#2F313C" d="M89.143 4.571h4.571v22.857h-4.571v-22.857z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 10,
      width: 32,
    },
    M: {
      height: 14,
      width: 44,
    },
    L: {
      height: 18,
      width: 57,
    },
  },
  actions: {
    rotate: true,
    text: false,
  },
};

export const HURDLE = {
  category: `equipment`,
  type: `hurdle`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="128" height="32" viewBox="0 0 128 32">
    <title>hurdle</title>
    <path d="M0 10.667h10.667v21.333h-10.667v-21.333z"></path>
    <path d="M117.333 10.667h10.667v21.333h-10.667v-21.333z"></path>
    <path d="M0 0h128v10.667h-128v-10.667z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 4,
      width: 16,
    },
    M: {
      height: 6,
      width: 24,
    },
    L: {
      height: 8,
      width: 32,
    },
  },
  actions: {
    rotate: true,
    text: false,
  },
};

export const SLALOM_POLE = {
  category: `equipment`,
  type: `slalom_pole`,
  svg: `
    <!-- Generated by IcoMoon.io -->
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="10" height="32" viewBox="0 0 10 32">
    <title>slalom-pole</title>
    <path d="M3.84 0h2.56v32h-2.56v-32z"></path>
    <path d="M5.12 24.32l5.12 7.68h-10.24l5.12-7.68z"></path>
    </svg>
  `,
  sizes: {
    S: {
      height: 16,
      width: 5,
    },
    M: {
      height: 25,
      width: 8,
    },
    L: {
      height: 38,
      width: 12,
    },
  },
  actions: {
    rotate: true,
    text: false,
  },
};

export const TEXT = {
  category: `text`,
  type: `text`,
  svg: null,
  sizes: null,
  actions: {
    rotate: true,
    text: false,
  },
  fontSizes: [
    { value: `10`, label: `10` },
    { value: `12`, label: `12` },
    { value: `14`, label: `14` },
    { value: `18`, label: `18` },
    { value: `24`, label: `24` },
    { value: `30`, label: `30` },
  ],
};

export const LINE_WITH_ARROW = {
  category: `paths`,
  type: `line_with_arrow`,
  svg: null,
  sizes: null,
  actions: {
    rotate: false,
    text: false,
  },
};

export const LEGACY_LINE_WITH_ARROW = {
  category: `lines`,
  type: `line_with_arrow`,
  svg: null,
  sizes: null,
  actions: {
    rotate: false,
    text: false,
  },
};

export const DASHED_LINE_WITH_ARROW = {
  category: `paths`,
  type: `dashed_line_with_arrow`,
  svg: null,
  sizes: null,
  actions: {
    rotate: false,
    text: false,
  },
};

export const LEGACY_DASHED_LINE_WITH_ARROW = {
  category: `lines`,
  type: `dashed_line_with_arrow`,
  svg: null,
  sizes: null,
  actions: {
    rotate: false,
    text: false,
  },
};

export const WAVY_LINE_WITH_ARROW = {
  category: `lines`,
  type: `wavy_line_with_arrow`,
  svg: null,
  sizes: null,
  actions: {
    rotate: false,
    text: false,
  },
};

export const DASHED_LINE = {
  category: `paths`,
  type: `dashed_line`,
  svg: null,
  sizes: null,
  actions: {
    rotate: false,
    text: false,
  },
};

export const LEGACY_DASHED_LINE = {
  category: `lines`,
  type: `dashed_line`,
  svg: null,
  sizes: null,
  actions: {
    rotate: false,
    text: false,
  },
};

export const SQUARE = {
  category: `shapes`,
  type: `square`,
  svg: null,
  sizes: null,
  actions: {
    rotate: true,
    text: false,
  },
};

export const RECTANGLE = {
  category: `shapes`,
  type: `rectangle`,
  svg: null,
  sizes: null,
  actions: {
    rotate: true,
    text: false,
  },
};

export const CIRCLE = {
  category: `shapes`,
  type: `circle`,
  svg: null,
  sizes: null,
  actions: {
    rotate: false,
    text: false,
  },
};

export const GRID = {
  category: `grid`,
  svg: null,
  sizes: null,
  actions: {
    rotate: false,
    text: false,
  },
};



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Items.js